const BASES = [
  'https://de1.api.radio-browser.info',
  'https://de2.api.radio-browser.info',
  'https://fi1.api.radio-browser.info',
  'https://at1.api.radio-browser.info',
];

let baseIdx = 0;

/** Upgrade http(s) asset URLs so HTTPS pages do not load mixed-content images. */
export function secureAssetUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  return trimmed.replace(/^http:\/\//i, 'https://');
}

/**
 * Playback URL order: prefer HTTPS to avoid mixed content; keep original HTTP
 * as a one-shot fallback when the source was insecure.
 */
export function streamPlayCandidates(url) {
  if (!url || typeof url !== 'string') return [];
  const trimmed = url.trim();
  if (!trimmed) return [];
  const secure = secureAssetUrl(trimmed);
  if (!secure) return [trimmed];
  if (secure === trimmed || /^https:\/\//i.test(trimmed)) return [secure];
  // http:// or // → try https first, then original (normalize // to http for fallback)
  const insecure = trimmed.startsWith('//') ? `http:${trimmed}` : trimmed;
  return [secure, insecure];
}

export async function api(path) {
  for (let i = 0; i < BASES.length; i++) {
    const b = BASES[(baseIdx + i) % BASES.length];
    try {
      const r = await fetch(b + path, { headers: { 'User-Agent': 'TheDome/1.0' } });
      if (!r.ok) throw new Error('bad status');
      baseIdx = (baseIdx + i) % BASES.length;
      return await r.json();
    } catch {
      /* next mirror */
    }
  }
  throw new Error('All mirrors unreachable');
}

export { BASES };
